import React from 'react';
import { Text } from 'lucide-react';

export default function AcronymCallToAction() {
  const scrollToGenerator = () => {
    document.getElementById('acronym-generator')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-20 bg-blue-600">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="flex justify-center mb-6">
          <Text className="w-12 h-12 text-blue-200" />
        </div>
        <h2 className="text-3xl font-bold text-white mb-4">
          Ready to Create Your Acronym?
        </h2>
        <p className="text-xl text-blue-100 mb-8">
          Join thousands of users who've created memorable acronyms with our specialized generator.
        </p>
        <button 
          onClick={scrollToGenerator}
          className="bg-white text-blue-600 text-lg px-8 py-4 rounded-lg hover:bg-blue-50 transition-colors cursor-pointer shadow-lg hover:shadow-xl"
        >
          Create Your Acronym Now!
        </button>
        <p className="mt-6 text-sm text-blue-200">
          Perfect for organizations, projects, and creative naming
        </p>
      </div>
    </section>
  );
}